<div class="page-body">
  <div *ngIf="!loading && error" class="error-wrapper">
    <div class="contents-container">
      <p class="heading">{{ translations.errorHeading }}</p>
      <p class="info-text">
        {{ translations.errorInfo }}
      </p>

      <div class="button-wrapper">
        <zaver-secondary-button-outlined
          class="error-button"
          [text]="translations.backButton"
          (click)="handleCancellation()"
          [rounded]="true"
          [disabled]="navigationInProgress"
        ></zaver-secondary-button-outlined>
      </div>
    </div>
  </div>

  <div *ngIf="loading && !error">
    <app-spinner [infoText]="translations.loading"></app-spinner>
  </div>

  <div *ngIf="!loading && !error">
    <div class="banner">
      <button type="button" class="back-button" (click)="backToPreviousStep()">
        <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
        <span class="back-text">{{
        translations.cancellationButton
      }}</span>
      </button>
    </div>

    <!-- Form to answer kalp questions. -->
    <div *ngIf="!viewReviewAnswers" class="contents-wrapper">
      <div class="contents-container">
        <form [formGroup]="formGroup" novalidate>
          <zaver-stepper [shouldHideDefaultButtons]="true">
            <!-- STEP 1 -->
            <ng-template #step let-index>
              <div>
                <div>
                  <div class="page-heading">
                    {{ translations.firstPageHeader }}
                  </div>

                  <p class="page-sub-heading">
                    {{ translations.firstPageSubHeader }}
                  </p>

                  <hr class="details-divider" />
                </div>
                <div class="page-content">
                  <div class="header">{{ translations.occupationHeader }}</div>
                  <div class="form-input-container">
                    <zaver-pill-selector
                      [(selectedOption)]="selectedOccupationOption"
                      [options]="occupationOptions"
                      (selectedOptionChange)="
                        onSelectedOccupationOptionChange($event)
                      "
                    >
                    </zaver-pill-selector>
                  </div>

                  <div class="form-input-container">
                    <zaver-animated-form-input
                      [ariaLabel]="translations.monthlyNetIncome"
                      [placeholder]="translations.monthlyNetIncome"
                      inputMode="numeric"
                      formControlName="monthlyNetIncome"
                      [error]="
                        formGroup.controls.monthlyNetIncome.invalid && showError
                      "
                      [errorMessage]="translations.monthlyNetIncomeError"
                      [errorIcon]="'assets/icon/icon_error.svg'"
                      [showContent]="true"
                    >
                      €
                    </zaver-animated-form-input>
                  </div>

                  <!-- NAME OF EMPLOYER EXTENDED -->
                  <div
                    *ngIf="shouldShowOccupationInputs"
                    class="form-input-container"
                  >
                    <zaver-animated-form-input
                      formControlName="nameOfEmployer"
                      [error]="
                        formGroup.controls.nameOfEmployer.invalid && showError
                      "
                      [ariaLabel]="translations.nameOfEmployer"
                      [placeholder]="translations.nameOfEmployer"
                      [errorMessage]="translations.nameOfEmployerError"
                      inputMode="text"
                      [errorIcon]="'assets/icon/icon_error.svg'"
                    ></zaver-animated-form-input>
                  </div>

                  <div
                    *ngIf="shouldShowOccupationInputs"
                    class="form-input-container"
                  >
                    <app-date-picker
                      [title]="translations.startDateHeader"
                      [placeholder]="translations.datePlaceholder"
                      [minDateInput]="minDueDate"
                      [maxDateInput]="maxDueDate"
                      [formGroup]="formGroup"
                      formName="startDate"
                      [showError]="showError"
                      [initialDate]="initialDate"
                      [customErrorMessage]="
                        translations.invalidEmploymentPeriod
                      "
                    >
                    </app-date-picker>
                  </div>

                  <app-date-picker
                    *ngIf="shouldShowOccupationInputs"
                    [title]="translations.endDateHeader"
                    [placeholder]="translations.datePlaceholder"
                    [minDateInput]="minDueDate"
                    [maxDateInput]="maxDueDate"
                    [formGroup]="formGroup"
                    formName="endDate"
                    [showError]="showError"
                    [initialDate]="initialDate"
                    [customErrorMessage]="translations.invalidEmploymentPeriod"
                    [isDateResettable]="true"
                    [resetDateForm]="resetEndDateForm"
                    [resetButtonText]="translations.resetEndDateText"
                    [isDisabled]="shouldDisableEndDate"
                  >
                  </app-date-picker>
                </div>
              </div>
            </ng-template>

            <!-- STEP 2 -->
            <ng-template #step let-index>
              <div>
                <div class="page-content">
                  <div class="header">
                    {{ translations.martialStatusHeader }}
                  </div>

                  <div class="form-input-container">
                    <zaver-pill-selector
                      [header]="translations.martialStatusPillHeader"
                      [options]="martialStatusOptions"
                      [(selectedOption)]="selectedMartialStatusOption"
                    >
                    </zaver-pill-selector>
                  </div>

                  <div class="form-input-container">
                    <zaver-pill-selector
                      [header]="translations.typeOfAccommodationPillHeader"
                      [options]="typeOfAccommodationOptions"
                      [(selectedOption)]="selectedTypeOfAccommodationOption"
                      (selectedOptionChange)="
                        onSelectedAccommodationOptionChange()
                      "
                    >
                    </zaver-pill-selector>
                  </div>

                  <div class="form-input-container">
                    <div class="slider-header">
                      {{ translations.sliderHeader }}
                    </div>
                    <zaver-list-slider
                      class="slider-container"
                      [ariaLabel]="translations.sliderHeader"
                      [listOptions]="leqKidsAnswers"
                      [initialValue]="leqKidsAnswers[0]"
                      [(value)]="sliderAnswer"
                    ></zaver-list-slider>
                  </div>

                  <div class="form-input-container">
                    <zaver-animated-form-input
                      formControlName="rentOrFeePerMonth"
                      [error]="
                        formGroup.controls.rentOrFeePerMonth.invalid &&
                        showError
                      "
                      [ariaLabel]="translations.rentOrFeePerMonth"
                      [placeholder]="translations.rentOrFeePerMonth"
                      [errorMessage]="translations.rentOrFeePerMonthError"
                      inputMode="text"
                      [errorIcon]="'assets/icon/icon_error.svg'"
                      [showContent]="true"
                      >€</zaver-animated-form-input
                    >
                    <div *ngIf="!shouldShowMortgageInputs" class="note-text">
                      {{ translations.inputNote }}
                    </div>
                  </div>

                  <div
                    *ngIf="shouldShowMortgageInputs"
                    class="form-input-container"
                  >
                    <zaver-animated-form-input
                      formControlName="totalMortgage"
                      [error]="
                        formGroup.controls.totalMortgage.invalid && showError
                      "
                      [ariaLabel]="translations.totalMortgage"
                      [placeholder]="translations.totalMortgage"
                      [errorMessage]="translations.totalMortgageError"
                      inputMode="text"
                      [errorIcon]="'assets/icon/icon_error.svg'"
                      [showContent]="true"
                      >€</zaver-animated-form-input
                    >
                  </div>

                  <div
                    *ngIf="shouldShowMortgageInputs"
                    class="form-input-container"
                  >
                    <zaver-animated-form-input
                      formControlName="mortgagePaymentPerMonth"
                      [error]="
                        formGroup.controls.mortgagePaymentPerMonth.invalid &&
                        showError
                      "
                      [ariaLabel]="translations.mortgagePaymentPerMonth"
                      [placeholder]="translations.mortgagePaymentPerMonth"
                      [errorMessage]="translations.mortgagePaymentPerMonthError"
                      inputMode="text"
                      [errorIcon]="'assets/icon/icon_error.svg'"
                      [showContent]="true"
                      >€</zaver-animated-form-input
                    >
                    <div class="note-text">{{ translations.inputNote }}</div>
                  </div>
                </div>
              </div>
            </ng-template>

            <!-- STEP 3 -->
            <ng-template #step let-index>
              <div>
                <div class="page-content">
                  <div class="header">
                    {{ translations.otherLoansAndCosts }}
                  </div>

                  <div class="form-input-container">
                    <zaver-animated-form-input
                      formControlName="totalAmountOfOtherLoans"
                      [error]="
                        formGroup.controls.totalAmountOfOtherLoans.invalid &&
                        showError
                      "
                      [ariaLabel]="translations.totalAmountOfOtherLoans"
                      [placeholder]="translations.totalAmountOfOtherLoans"
                      [errorMessage]="translations.totalAmountOfOtherLoansError"
                      inputMode="text"
                      [errorIcon]="'assets/icon/icon_error.svg'"
                      [showContent]="true"
                      >€</zaver-animated-form-input
                    >
                  </div>

                  <div class="form-input-container">
                    <zaver-animated-form-input
                      formControlName="monthlyObligationForOtherLoans"
                      [error]="
                        formGroup.controls.monthlyObligationForOtherLoans
                          .invalid && showError
                      "
                      [ariaLabel]="translations.monthlyObligationForOtherLoans"
                      [placeholder]="
                        translations.monthlyObligationForOtherLoans
                      "
                      [errorMessage]="
                        translations.monthlyObligationForOtherLoansError
                      "
                      inputMode="text"
                      [errorIcon]="'assets/icon/icon_error.svg'"
                      [showContent]="true"
                      >€</zaver-animated-form-input
                    >
                  </div>

                  <div class="form-input-container">
                    <zaver-animated-form-input
                      formControlName="monthlyLivingExpenses"
                      [error]="
                        formGroup.controls.monthlyLivingExpenses.invalid &&
                        showError
                      "
                      [ariaLabel]="translations.monthlyLivingExpenses"
                      [placeholder]="translations.monthlyLivingExpenses"
                      [errorMessage]="translations.monthlyLivingExpensesError"
                      inputMode="text"
                      [errorIcon]="'assets/icon/icon_error.svg'"
                      [showContent]="true"
                      >€</zaver-animated-form-input
                    >
                    <div class="note-text">{{ translations.inputNote }}</div>
                  </div>
                </div>
              </div>
            </ng-template>
          </zaver-stepper>
        </form>

        <zaver-primary-button
          class="continue-button"
          [text]="translations.continueButton"
          (click)="handleCtaClick()"
        ></zaver-primary-button>
      </div>
    </div>

    <!-- VIEW REVIEW (Same as the review page) -->
    <div *ngIf="viewReviewAnswers" class="contents-wrapper">
      <div class="contents-container">
        <div class="page-header-container">
          <div class="page-heading">
            {{ translations.reviewFirstPageHeader }}
          </div>

          <p class="page-sub-heading">
            {{ translations.reviewfirstPageSubHeader }}
          </p>
        </div>

        <div *ngIf="kalpAnswers.occupation">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.reviewOccupation }}</div>
            <div>
              {{ getOccupationOptionsTranslations(kalpAnswers.occupation) }}
            </div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.monthlyNetIncome">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.reviewMonthlyNetIncome }}</div>
            <div>{{ kalpAnswers.monthlyNetIncome }}{{ currencySymbol }}</div>
          </div>
        </div>

        <!-- REMOVE IN BASE-->
        <div *ngIf="kalpAnswers.nameOfEmployer">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.nameOfEmployer }}</div>
            <div>{{ kalpAnswers.nameOfEmployer }}</div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.martialStatus">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.reviewMartialStatus }}</div>
            <div>
              {{
                getMartialStatusOptionsTranslations(kalpAnswers.martialStatus)
              }}
            </div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.typeOfAccommodation">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.reviewTypeOfAccommodation }}</div>
            <div>
              {{
                getTypeOfAccommodationOtionsTranslations(
                  kalpAnswers.typeOfAccommodation
                )
              }}
            </div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.amountOfChildren">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.reviewAmountOfChildren }}</div>
            <div>{{ kalpAnswers.amountOfChildren }}</div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.rentOrFeePerMonth">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.rentOrFeePerMonth }}</div>
            <div>{{ kalpAnswers.rentOrFeePerMonth }}{{ currencySymbol }}</div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.totalMortgage">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.reviewTotalMortgage }}</div>
            <div>{{ kalpAnswers.totalMortgage }}{{ currencySymbol }}</div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.mortgagePaymentPerMonth">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.reviewMortgagePaymentPerMonth }}</div>
            <div>
              {{ kalpAnswers.mortgagePaymentPerMonth }}{{ currencySymbol }}
            </div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.totalAmountOfOtherLoans">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.totalAmountOfOtherLoans }}</div>
            <div>
              {{ kalpAnswers.totalAmountOfOtherLoans }}{{ currencySymbol }}
            </div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.monthlyObligationForOtherLoans">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.monthlyObligationForOtherLoans }}</div>
            <div>
              {{ kalpAnswers.monthlyObligationForOtherLoans
              }}{{ currencySymbol }}
            </div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.monthlyLivingExpenses">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.reviewMonthlyLivingExpenses }}</div>
            <div>
              {{ kalpAnswers.monthlyLivingExpenses }}{{ currencySymbol }}
            </div>
          </div>
          <hr class="details-divider" />
        </div>

        <zaver-primary-button
          class="continue-button"
          [text]="translations.continueButton"
          (click)="handleCtaClickReview()"
        ></zaver-primary-button>

        <zaver-secondary-button-outlined
          class="update-button"
          [text]="translations.updateButton"
          (click)="handleUpdateClick()"
        ></zaver-secondary-button-outlined>
      </div>
    </div>
  </div>
</div>
